module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Da-Fb-Gd-Hc-Ia.8c3e6198.png";